@use "variables" as *;

.cancelButton {
  color: indianred;
}

.textField {
  display: flex;
  height: 60px;
  padding: $spacing-xs;
}

.itemContainer {
  min-width: 200px;
}

.loadingDiv {
  width: 50px;
  padding-left: $spacing-m;
}

.dropzone {
  height: 140px !important;
  width: 140px !important;
  align-self: center;
  flex-shrink: 0;
}

.counter {
  margin-top: $spacing-s;
  margin-left: $spacing-xl;
  align-self: center;
}

.booleansSection {
  margin-bottom: $spacing-s;
}

.itemTitle {
  font-size: $fontSize-s !important;
  margin-left: $spacing-xs !important;
}

.expandIconDiv {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: $spacing-s;
}
